import { render, staticRenderFns } from "./PayInvoicePage.vue?vue&type=template&id=10c8cb43&"
import script from "./PayInvoicePage.vue?vue&type=script&lang=js&"
export * from "./PayInvoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports